import { SalaryDetailModel } from "@/model/salary/salaryDetailModel";
import { PaymentModel, SalaryEmployeeModel, SalaryEmployeeRevenueDeductModel } from "@/model/salary/salaryModel";
export function ConvertToSummarySalaryTable(_table: any) {
  const table = {
    count: 0,
    summarySalaryTableList: [] as any,
  };
  if (_table) {
    table.count = _table.count;
    if (_table.summarySalaryTableList && _table.summarySalaryTableList.length > 0) {
      _table.summarySalaryTableList.forEach((_summarySalaryTable: any) => {
        const summarySalaryTable = {
          code: _summarySalaryTable.code,
          createDateTime: _summarySalaryTable.createDateTime.NewDateTimeUctToTimezone(),
          createUserId: _summarySalaryTable.createUserId,
          deductTotal: _summarySalaryTable.deductTotal,
          employeeCount: _summarySalaryTable.employeeCount,
          fromDate: _summarySalaryTable.fromDate,
          id: _summarySalaryTable.id,
          isDeleted: _summarySalaryTable.isDeleted,
          merchantId: _summarySalaryTable.merchantId,
          paymentAmount: _summarySalaryTable.paymentAmount,
          payrunCount: _summarySalaryTable.payrunCount,
          revenueTotal: _summarySalaryTable.revenueTotal,
          salaryTotal: _summarySalaryTable.salaryTotal,
          socialSecurityEmployeeTotal: _summarySalaryTable.socialSecurityEmployeeTotal,
          socialSecurityEmployerTotal: _summarySalaryTable.socialSecurityEmployerTotal,
          socialSecurityPayableTotal: _summarySalaryTable.socialSecurityPayableTotal,
          toDate: _summarySalaryTable.toDate,
          whtPayableTotal: _summarySalaryTable.whtPayableTotal,
          whtTotal: _summarySalaryTable.whtTotal,
        };
        table.summarySalaryTableList.push(summarySalaryTable);
      });
    }
  }

  return table;
}
export function ConvertToSalaryDetail(salaryDetail: any): SalaryDetailModel {
  const salaryDetailModel: SalaryDetailModel = {
    id: salaryDetail.id,
    merchantId: salaryDetail.merchantId,
    number: salaryDetail.number,
    issuedDate: salaryDetail.issuedDate,
    dueDate: salaryDetail.dueDate,
    fromDate: salaryDetail.fromDate,
    toDate: salaryDetail.toDate,
    status: salaryDetail.status,
    salaryTotal: salaryDetail.salaryTotal,
    revenueTotal: salaryDetail.revenueTotal,
    deductionTotal: salaryDetail.deductionTotal,
    whtPayableTotal: salaryDetail.whtPayableTotal,
    socialSecurityPayableTotal: salaryDetail.socialSecurityPayableTotal,
    socialSecurityEmployeeTotal: salaryDetail.socialSecurityEmployeeTotal,
    socialSecurityEmployerTotal: salaryDetail.socialSecurityEmployerTotal,
    whtTotal: salaryDetail.whtTotal,
    netAmount: salaryDetail.netAmount,
    taxCalculatedAmount: salaryDetail.taxCalculatedAmount,
    socialSecurityCalculatedAmount: salaryDetail.socialSecurityCalculatedAmount,
    grossSalaryAmount: salaryDetail.grossSalaryAmount,
    salaryIssuedDay: salaryDetail.salaryIssuedDay,
    salaryIssuedMonth: salaryDetail.salaryIssuedMonth,
    salaryIssuedYear: salaryDetail.salaryIssuedYear,
    regularTotal: salaryDetail.regularTotal,
    irregularTotal: salaryDetail.irregularTotal,
    isDeleted: salaryDetail.isDeleted,
    employeeList: [],
    salaryBankAccountId: salaryDetail.salaryBankAccountId,
    salaryExpenseNumber: salaryDetail.salaryExpenseNumber,
    salaryExpenseId: salaryDetail.salaryExpenseId,
    salaryPaymentDate: salaryDetail.salaryPaymentDate,
    salaryPaymentRemark: salaryDetail.salaryPaymentRemark,
    issuedSalaryExpenseStatusType: salaryDetail.issuedSalaryExpenseStatusType,
    ssoBankAccountId: salaryDetail.ssoBankAccountId,
    ssoPaymentDate: salaryDetail.ssoPaymentDate,
    ssoExpenseNumber: salaryDetail.ssoExpenseNumber,
    ssoExpenseId: salaryDetail.ssoExpenseId,
    ssoPaymentRemark: salaryDetail.ssoPaymentRemark,
    isIssuedStatement: salaryDetail.isIssuedStatement,
    isUseSummary: salaryDetail.isUseSummary,
    ewfExpenseId: salaryDetail.ewfExpenseId ?? 0,
    ewfExpenseNumber: salaryDetail.ewfExpenseNumber ?? "",
    employeeWelfareFundPayableTotal: salaryDetail.employeeWelfareFundPayableTotal,
    employeeWelfareFundEmployeeTotal: salaryDetail.employeeWelfareFundEmployeeTotal,
    employeeWelfareFundEmployerTotal: salaryDetail.employeeWelfareFundEmployerTotal,
  };

  if (salaryDetail && salaryDetail.employeeList.length > 0) {
    salaryDetail.employeeList.forEach((employee: any) => {
      const salaryEmployeeModel: SalaryEmployeeModel = {
        id: employee.id,
        salaryId: employee.salaryId,
        employeeId: employee.employeeId,
        positionId: employee.positionId,
        departmentId: employee.departmentId,
        salaryTotal: employee.salaryTotal,
        revenueTotal: employee.revenueTotal,
        deductionTotal: employee.deductionTotal,
        whtTotal: employee.whtTotal,
        netAmount: employee.netAmount,
        socialSecurityFundTotal: employee.socialSecurityFundTotal,
        providentFundTotal: employee.providentFundTotal,
        taxCalculatedAmount: employee.taxCalculatedAmount,
        socialSecurityCalculatedAmount: employee.socialSecurityCalculatedAmount,
        grossSalaryAmount: employee.grossSalaryAmount,
        regularTotal: employee.regularTotal,
        irregularTotal: employee.irregularTotal,
        revenueDeductList: [],
        employeeWelfareFundTotal: employee.employeeWelfareFundTotal,
        employeeWelfareFundCalculatedAmount: employee.employeeWelfareFundCalculatedAmount,
      };

      if (employee.revenueDeductList.length > 0) {
        employee.revenueDeductList.forEach((revenueDeduct: any) => {
          const salaryEmployeeRevenueDeductModel: SalaryEmployeeRevenueDeductModel = {
            id: revenueDeduct.id,
            salaryEmployeeId: revenueDeduct.salaryEmployeeId,
            revenueDeductId: revenueDeduct.revenueDeductId,
            accountId: revenueDeduct.accountId,
            total: revenueDeduct.total,
            revenueDeductType: revenueDeduct.revenueDeductType,
          };
          salaryEmployeeModel.revenueDeductList.push(salaryEmployeeRevenueDeductModel);
        });
      }

      salaryDetailModel.employeeList.push(salaryEmployeeModel);
    });
  }

  return salaryDetailModel;
}

export function ConvertToSalaryCommentLog(_commentList: Array<any>) {
  const commentList: any = [];
  if (_commentList.length > 0) {
    _commentList.forEach((item: any) => {
      commentList.push({
        actionDateTime: item.actionDateTime,
        actionUserId: item.actionUserId,
        commentId: item.commentId,
        commentLogType: item.commentLogType,
        data: item.data,
        note: item.note,
      });
    });
  }
  return commentList;
}

export function GetValidateBeforeUpdateSalaryPaidRequest(input: { salaryId: number; payment: PaymentModel }) {
  return {
    salaryId: input.salaryId,
    payment: input.payment,
  };
}

export function GetUpdateSalaryPaidRequest(input: {
  salaryId: number;
  insertedExpenseId: number;
  insertedExpenseNumber: string;
  payment: PaymentModel;
}) {
  return {
    salaryId: input.salaryId,
    insertedExpenseId: input.insertedExpenseId,
    insertedExpenseNumber: input.insertedExpenseNumber,
    payment: input.payment,
  };
}

export function GetValidateBeforeUpdateSalarySSOPaidRequest(input: { salaryId: number; payment: PaymentModel }) {
  return {
    salaryId: input.salaryId,
    payment: input.payment,
  };
}
export function GetValidateBeforeUpdateSalaryEWFPaidRequest(input: { salaryId: number; payment: PaymentModel }) {
  return {
    salaryId: input.salaryId,
    payment: input.payment,
  };
}
export function GetUpdateSalarySSOPaidRequest(input: {
  salaryId: number;
  insertedExpenseId: number;
  insertedExpenseNumber: string;
  payment: PaymentModel;
}) {
  return {
    salaryId: input.salaryId,
    insertedExpenseId: input.insertedExpenseId,
    insertedExpenseNumber: input.insertedExpenseNumber,
    payment: input.payment,
  };
}
export function GetUpdateSalaryEWFPaidRequest(input: {
  salaryId: number;
  insertedExpenseId: number;
  insertedExpenseNumber: string;
  payment: PaymentModel;
}) {
  return {
    salaryId: input.salaryId,
    insertedExpenseId: input.insertedExpenseId,
    insertedExpenseNumber: input.insertedExpenseNumber,
    payment: input.payment,
  };
}
export function GetValidateBeforeUpdateSalaryExpenseRequest(input: { salaryId: number; payment: PaymentModel }) {
  return {
    salaryId: input.salaryId,
    payment: input.payment,
  };
}

export function GetUpdateSalaryExpenseRequest(input: {
  salaryId: number;
  insertedExpenseId: number;
  insertedExpenseNumber: string;
}) {
  return {
    salaryId: input.salaryId,
    insertedExpenseId: input.insertedExpenseId,
    insertedExpenseNumber: input.insertedExpenseNumber,
  };
}
